import { SignUpActions } from ".";

let initialState = {
  signUpInProgress: false,
  user: [],
  storedUser: []
};

const signUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case SignUpActions.SIGNUP_IN_PROGRESS:
      return { ...state, signUpInProgress: true };
    case SignUpActions.SIGNUP_COMPLETE:
      return { ...state, signUpInProgress: false, data: action.data };
    case SignUpActions.STORE_USER_COMPLETE:
      return { ...state, signUpInProgress: false, storedUser: action.data };
    default:
      return state;
  }
};

export default signUpReducer;
